import { Box, BoxProps } from '../layout';

export const TableCell = ({ children, ...restProps }: BoxProps) => (
  <Box display={'flex'} alignItems={'center'} height={'100%'} {...restProps}>
    {children}
  </Box>
);
